module.exports = __webpack_public_path__ + "img/thumbnail_CommonOstrich_j_albino.9d8b88b6.png";